
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const WordTilesPage = lazy(() => import('./NameAnalysisRenew'));
const path = 'reports/subword-frequency/renew';
const WordTilesRoute: FuseRouteItemType = {
	path: path,
	element: <WordTilesPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Name Analysis for Renew',
					showCrumbs: false,
					helpName: 'Name Analysis for Renew'
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default WordTilesRoute;
